export default __webpack_public_path__ + "40ac24a2af2af0fd563149a9630767b7.png";